import { useEffect, useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
import { createImageUrl } from '../../../../../../../helper/Converters';
import { translate } from '../../../../../../../utils/language';

const ProductDetail_3 = ({ item }) => {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  const image = createImageUrl(firstProduct?.variants?.[0]?.images?.[0]?.id);
  const rating = 5;
  const totalStars = 5;
  const emptyColors = ['black', 'yellow', 'blue', 'green'];
  console.log(item);
  const VariantColors = ({ customization, staticValues, image, index, isColor, text, isActive }) => {
    return (
      <div className="flex flex-col">
        <div
          className="overflow-hidden"
          style={
            isActive
              ? {
                  width: 120,
                  height: 80,
                  borderWidth: staticValues[2],
                  borderColor: '#2126AB',
                  borderRadius: 5,
                  flexShrink: 0,
                }
              : {
                  width: 120,
                  height: 80,
                  borderWidth: staticValues[2],
                  borderColor: '#E5E5E5',
                  borderRadius: 5,
                  flexShrink: 0,
                }
          }
        >
          {customization?.colorVariant_ImageType === 'text' ? (
            <div
              className="flex w-full h-full justify-center items-center break-words "
              style={{
                color: isActive
                  ? customization?.colorVariant_SelectedTextColor
                  : customization?.colorVariant_DefaultTextColor,
                backgroundColor: isActive
                  ? customization?.colorVariant_SelectedTextBackgroundColor
                  : customization?.colorVariant_DefaultTextBackgroundColor,
              }}
            >
              {text || translate('exampleVariant')}
            </div>
          ) : isColor ? (
            <div className="w-full h-full" style={{ background: image }}></div>
          ) : (
            <img
              src={image || process.env.REACT_APP_DEFAULT_IMAGE}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const VariantTexts = ({ customization, staticValues, text, isActive }) => {
    return (
      <div className="flex flex-col">
        <div
          className="overflow-hidden word-break truncate"
          style={{
            padding: customization?.textVariant_BoxesPadding,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderWidth: 1,
            borderColor: isActive
              ? customization?.textVariant_SelectedVariantBorderColor
              : customization?.textVariant_DefaultVariantBorderColor,
            borderRadius: customization?.textVariant_BoxesBorderRadius,
            backgroundColor: isActive
              ? customization?.textVariant_SelectedVariantBackgroundColor
              : customization?.textVariant_DefaultVariantBackgroundColor,
            width: customization?.textVariant_BoxesWidth,
            height: customization?.textVariant_BoxesHeight,
            fontSize: staticValues[12],
            color: isActive
              ? customization?.textVariant_SelectedVariantTextColor
              : customization?.textVariant_DefaultVariantTextColor,
            flexShrink: 0,
          }}
        >
          {text || translate('exampleVariant')}
        </div>
      </div>
    );
  };

  const [hashMap, setHashMap] = useState({});
  const products = useSelector(state => state.themeSlice.products);
  const firstVariant = products && Object.values(products)?.[0]?.data;
  const productVariantTypes = firstVariant?.productVariantTypes;
  const firsVariantHash = productVariantTypes
    ?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return variantTypeId + variantValueIds?.[0];
    })
    ?.join(';');
  const iscolorVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'COLOR');
  const istextVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'CHOICE');
  console.log(iscolorVariant_Exists);
  useEffect(() => {
    const variantTypeValueArray = firstVariant?.productVariantTypes?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return { variantTypeId, variantValueIds };
    });

    const objectMap = {};
    firstVariant?.variants?.map(variant => {
      const keyArr = [];
      const variantValues = variant?.variantValues;
      variantValues?.map(v => {
        const variantTypeId = v?.variantTypeId;
        const variantValueId = v?.variantValueId;
        const typeIndex = variantTypeValueArray?.findIndex(
          variantTypeValue => variantTypeValue?.variantTypeId === variantTypeId,
        );
        if (typeIndex !== -1) {
          keyArr[typeIndex] = variantTypeId + variantValueId;
        }
      });
      const key = keyArr?.join(';');
      objectMap[key] = variant;
    });
    setHashMap(objectMap);
  }, []);

  console.log('Abdullah', firstProduct);

  return (
    <div className="mx-1 pb-5">
      <div className="relative ">
        <img
          width={'100%'}
          style={{ height: customization?.productImageHeight, objectFit: customization?.backgroundSize }}
          src={image || process.env.REACT_APP_DEFAULT_IMAGE}
          alt=""
        />
        <div className="absolute top-0 right-0 bg-[#ED2727] text-white px-2 py-1">
          <div
            style={{
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            %22
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            İNDİRİM
          </div>
        </div>
        <div
          className="mx-3"
          style={{
            paddingTop: staticValues[10],
            paddingBottom: staticValues[10],
            display: 'flex',
            gap: staticValues[10],
            overflow: 'hidden',
            borderRadius: 5,
          }}
        >
          {firstProduct?.variants?.[0]?.images?.map((image, index) => (
            <img
              className={`border-2 p-1 ${index === 0 ? 'border-[#2126AB]' : 'border-[#EAEBED]'}`}
              src={createImageUrl(image?.id)}
              style={{ aspectRatio: 1, width: staticValues[40], objectFit: 'cover', borderRadius: 5 }}
            />
          ))}
        </div>
        <div className=" border-stone-300 mx-3">
          {
            <div style={{ display: 'flex', gap: '2px' }}>
              {[...Array(totalStars)].map((item, index) => {
                const starIndex = index + 1;

                return (
                  <span
                    key={starIndex}
                    style={{
                      cursor: 'pointer',
                      color: starIndex <= rating ? '#FFD700' : '#ccc',
                      fontSize: 14,
                    }}
                  >
                    &#9733;
                  </span>
                );
              })}
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#000000',
                  fontWeight: 600,
                  fontSize: 12,
                  marginLeft: 5,
                }}
              >
                1398 YORUM
              </span>
            </div>
          }
          {/* {customization?.showBrandName === 'show' && (
            <div
              className="flex flex-row justify-between align-center "
              style={{
                fontSize: customization?.brandNameTextSize,
                color: customization?.brandNameTextColor,
                fontStyle: customization?.brandNameTextStyle,
                fontWeight: customization?.brandNameTextWeight,
                paddingTop: staticValues[10],
              }}
            >
              {firstProduct?.brand?.name || 'Ürün Markası'}
            </div>
          )} */}

          <div className={`${'flex flex-row justify-between align-center'}`}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                textAlign: 'left',
              }}
            >
              <div
                style={{
                  textAlign: 'left',
                  fontSize: 18,
                  color: '#000000',
                  fontStyle: 'normal',
                  fontWeight: 600,
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: firstProduct?.name || 'Ürün Başlığı' }}></div>
              </div>
              <div
                style={{
                  textAlign: 'left',
                  fontSize: 14,
                  color: '#636363',
                  fontStyle: 'normal',
                  fontWeight: 400,
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: firstProduct?.description || 'Ürün Başlığı' }}></div>
              </div>
            </div>

            {/* <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0, gap: 5 }}>
              {customization?.isHeartIcon && (
                <div
                  className=" 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px] right-0"
                  style={{
                    backgroundColor: customization?.heartIconBackgroundColor,
                    borderRadius: customization?.heartIconBorderRadius,
                  }}
                >
                  <img
                    className="shrink-0"
                    src={customization?.heartIcon}
                    alt=""
                    style={{ filter: heartIconFilter, width: customization?.heartIconWidth }}
                  />
                </div>
              )}
              {customization?.isShareIcon && (
                <div
                  className=" 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px] right-0"
                  style={{
                    backgroundColor: customization?.shareIconBackgroundColor,
                    borderRadius: customization?.shareIconBorderRadius,
                  }}
                >
                  <img
                    className="shrink-0"
                    src={customization?.shareIcon}
                    alt=""
                    style={{ filter: shareIconFilter, width: customization?.shareIconWidth }}
                  />
                </div>
              )}
            </div> */}
          </div>
          <div
            style={{
              display: 'flex',
              gap: 5,
              alignItems: 'center',
              marginTop: 5,
              borderBottom: '1px solid #E5E5E5',
              paddingBottom: 10,
            }}
          >
            <div class="flex items-center justify-center gap-[5px] text-[12px]   px-1 py-1 px-[10px] py-[6px] bg-[#f3f3f3] rounded">
              <img
                src="https://proteinocean.com/vegeterian.png"
                style={{
                  width: 14,
                  height: 14,
                }}
              />
              VEJETARYEN
            </div>
            <div class="flex items-center justify-center gap-[5px] text-[12px]  px-1 py-1 px-[10px] py-[6px] bg-[#f3f3f3] rounded">
              <img
                src="https://proteinocean.com/gluten-free.png"
                style={{
                  width: 14,
                  height: 14,
                }}
              />
              GLUTENSİZ
            </div>
          </div>

          {/* {
            <div className="flex flex-row gap-2">
              {firstProduct?.tags?.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    backgroundColor: customization?.tagBackgroundColor,
                    width: 'fit-content',
                    borderRadius: customization?.tagBorderRadius,
                    padding: customization?.tagBoxPadding,
                    marginTop: '10px',

                    marginBottom: '10px',
                  }}
                >
                  <div>
                    <svg
                      fill={customization?.tagIconColor}
                      width={customization?.tagIconSize}
                      height={customization?.tagIconSize}
                      viewBox="0 0 30.72 30.72"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m30.719 12.488 0 -10.151c0 -1.288 -1.048 -2.337 -2.336 -2.337H18.022c-0.65 0 -1.635 0 -2.278 0.643L0.566 15.822c-0.365 0.365 -0.566 0.849 -0.566 1.365 0 0.516 0.201 1.001 0.565 1.366l11.604 11.602C12.533 30.519 13.017 30.72 13.533 30.72s1.001 -0.201 1.365 -0.565l15.179 -15.179c0.651 -0.649 0.647 -1.584 0.643 -2.487zm-2.001 1.13L13.526 28.796 1.924 17.18 17.086 2.015c0.153 -0.095 0.702 -0.095 0.93 -0.095l0.432 0.001 9.936 -0.001c0.23 0 0.416 0.187 0.416 0.417V12.496c0.002 0.365 0.004 0.976 -0.081 1.122M23.04 3.84c-2.121 0 -3.84 1.719 -3.84 3.84s1.719 3.84 3.84 3.84 3.84 -1.719 3.84 -3.84 -1.719 -3.84 -3.84 -3.84m0 5.76c-1.06 0 -1.92 -0.86 -1.92 -1.92s0.86 -1.92 1.92 -1.92 1.92 0.86 1.92 1.92 -0.86 1.92 -1.92 1.92" />
                    </svg>
                  </div>
                  <div
                    style={{
                      fontSize: customization?.tagTextSize,
                      color: customization?.tagTextColor,
                      fontStyle: customization?.tagTextStyle,
                      fontWeight: customization?.tagTextWeight,
                    }}
                  >
                    {item?.name}
                  </div>
                </div>
              ))}
            </div>
          } */}
        </div>
      </div>
      {firstProduct?.productVariantTypes?.[0]?.variantType?.selectionType === 'COLOR' && (
        <div
          className="mx-3"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
            marginTop: 10,
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: 18,
              textAlign: 'left',
            }}
          >
            AROMA:
          </div>
          <div
            style={{
              display: 'flex',
              gap: staticValues[5],
              marginRight: 10,
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'thin',
              paddingBottom: 5,
            }}
          >
            {firstProduct?.productVariantTypes?.[0]?.variantType?.selectionType === 'COLOR' &&
              firstProduct?.productVariantTypes?.[0]?.variantType?.values?.map((item, index) => (
                <div style={{ flexShrink: 0, position: 'relative', marginTop: 8 }}>
                  <img
                    className={`border-2 p-1 ${index === 0 ? 'border-[#2126AB]' : 'border-[#EAEBED]'}`}
                    src={createImageUrl(item?.thumbnailImageId)}
                    style={{ aspectRatio: 1, width: staticValues[55], objectFit: 'cover', borderRadius: 5 }}
                  />
                  <div
                    style={{
                      width: staticValues[55],
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'normal',
                      fontSize: 12,
                      fontWeight: 500,
                    }}
                  >
                    {item?.name}
                  </div>
                  <div
                    style={{
                      zIndex: 12132132,
                      backgroundColor: '#2126AB',
                      width: 20,
                      height: 20,
                      borderRadius: 99,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: index === 0 ? 'absolute' : 'unset',
                      visibility: index === 0 ? 'visible' : 'hidden',
                      top: -8,
                      right: -5,
                    }}
                  >
                    <svg
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                      stroke-width="0"
                      viewBox="0 0 12 16"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                      class="text-sm"
                    >
                      <path fill-rule="evenodd" d="M12 5l-8 8-4-4 1.5-1.5L4 10l6.5-6.5L12 5z"></path>
                    </svg>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {firstProduct?.productVariantTypes?.[1]?.variantType?.selectionType === 'CHOICE' && (
        <div
          className="mx-3"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
            marginTop: 10,
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: 18,
              textAlign: 'left',
            }}
          >
            BOYUT:
          </div>
          <div
            style={{
              display: 'flex',
              gap: staticValues[5],
              marginRight: 10,
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'thin',
              paddingBottom: 5,
            }}
          >
            {firstProduct?.productVariantTypes?.[1]?.variantType?.selectionType === 'CHOICE' &&
              firstProduct?.productVariantTypes?.[1]?.variantType?.values?.map((item, index) => (
                <div
                  className={`border-2  ${index === 0 ? 'border-[#2126AB]' : 'border-[#EAEBED]'}`}
                  style={{ flexShrink: 0, position: 'relative', marginTop: 8 }}
                >
                  <img
                    src={createImageUrl(item?.thumbnailImageId)}
                    style={{
                      aspectRatio: 1,
                      width: staticValues[80],
                      height: staticValues[80],
                      objectFit: 'contain',
                      borderRadius: 5,
                    }}
                  />
                  <div
                    style={{
                      zIndex: 12132132,
                      backgroundColor: '#2126AB',
                      width: 20,
                      height: 20,
                      borderRadius: 99,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: index === 0 ? 'absolute' : 'unset',
                      display: index === 0 ? 'flex' : 'none',
                      top: -8,
                      right: -5,
                    }}
                  >
                    <svg
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                      stroke-width="0"
                      viewBox="0 0 12 16"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                      class="text-sm"
                    >
                      <path fill-rule="evenodd" d="M12 5l-8 8-4-4 1.5-1.5L4 10l6.5-6.5L12 5z"></path>
                    </svg>
                  </div>
                  <div
                    className="truncate"
                    style={{
                      fontWeight: 500,
                      fontSize: 12,
                      paddingBottom: 5,
                    }}
                  >
                    {item?.name}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      <div className="flex flex-col items-center mx-3 gap-2">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: 18,
            }}
          >
            649 TL
          </div>
          <div
            style={{
              fontWeight: 600,
              fontSize: 12,
              color: '#333333',
            }}
          >
            40.56 TL / Servis
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            gap: 10,
          }}
        >
          <div className="flex items-center border rounded-md overflow-hidden">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#F3F4F6',
                color: '#000000',
                padding: '10px',
              }}
            >
              -
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
                color: '#000000',
                padding: '10px 14px',
              }}
            >
              1
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#F3F4F6',
                color: '#000000',
                padding: '10px',
              }}
            >
              +
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#2126AB',
              color: '#FFFFFF',
              padding: '10px',
              borderRadius: 5,
              fontWeight: 600,
              fontSize: 14,
              gap: 5,
            }}
          >
            <svg width="22px" height="20px" viewBox="0 0 27 26" version="1.1">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-1322.000000, -842.000000)" fill="#FFFFFF" fill-rule="nonzero">
                  <g id="879764" transform="translate(1322.000000, 842.000000)">
                    <path
                      d="M26.8293516,3.44557895 C26.6815371,3.26121053 26.4577852,3.15389474 26.221166,3.15389474 L5.49239063,3.15389474 L4.91273438,0.647052632 C4.8311543,0.294368421 4.51648828,0.0445263158 4.15383398,0.0445263158 L0.778833984,0.0445263158 C0.348732422,0.0445263158 0,0.392578947 0,0.821894737 C0,1.25121053 0.348732422,1.59921053 0.778833984,1.59921053 L3.53425781,1.59921053 L7.468875,18.6161053 C7.55040234,18.9687895 7.86512109,19.2186316 8.22777539,19.2186316 L23.832668,19.2186316 C24.2628223,19.2186316 24.611502,18.8705789 24.611502,18.4413158 C24.611502,18.012 24.2627695,17.664 23.832668,17.664 L8.8474043,17.664 L8.2483418,15.0728947 L23.8846641,15.0728947 C24.2489531,15.0728947 24.5645684,14.8208947 24.6445137,14.4662105 L26.9810156,4.10184211 C27.032959,3.87142105 26.977166,3.63 26.8293516,3.44557895 Z M23.2615547,13.5182105 L7.88885156,13.5182105 L5.85188086,4.70852632 L25.247584,4.70852632 L23.2615547,13.5182105 Z"
                      id="Shape"
                    ></path>
                    <path
                      d="M11.4230566,20.2550526 C9.8484082,20.2550526 8.5672793,21.5336316 8.5672793,23.1052632 C8.5672793,24.6768947 9.84835547,25.9554737 11.4230566,25.9554737 C12.9977051,25.9554737 14.278834,24.6768947 14.278834,23.1052632 C14.278834,21.5336316 12.9977578,20.2550526 11.4230566,20.2550526 Z M11.4230566,24.4008421 C10.707293,24.4008421 10.125,23.8196316 10.125,23.1052632 C10.125,22.3908947 10.707293,21.8097368 11.4230566,21.8097368 C12.1388203,21.8097368 12.7211133,22.3908947 12.7211133,23.1052632 C12.7211133,23.8196316 12.1388203,24.4008421 11.4230566,24.4008421 Z"
                      id="Shape"
                    ></path>
                    <path
                      d="M20.7692227,20.2550526 C19.1945742,20.2550526 17.9134453,21.5336316 17.9134453,23.1052632 C17.9134453,24.6768947 19.1945215,25.9554737 20.7692227,25.9554737 C22.3438711,25.9554737 23.625,24.6768947 23.625,23.1052632 C23.625,21.5336316 22.3439238,20.2550526 20.7692227,20.2550526 Z M20.7692227,24.4008421 C20.053459,24.4008421 19.471166,23.8196842 19.471166,23.1053158 C19.471166,22.3909474 20.053459,21.8097895 20.7692227,21.8097895 C21.4849863,21.8097895 22.0672793,22.3909474 22.0672793,23.1053158 C22.0672793,23.8196842 21.4849863,24.4008421 20.7692227,24.4008421 Z"
                      id="Shape"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
            SEPETE EKLE
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail_3;
